import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-68" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-69" data-mp="4lqj4w64bd3i">
        

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif",
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px",
        fontSize: "21px"
      }} data-id="element-70" data-mp="12a0j75mcfqrz">
          Everything you need to know to relieve, strengthen, and protect your back TODAY !
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "14px",
        paddingBottom: "20px",
        fontSize: "11px"
      }} data-id="element-71" data-mp="nekmesudpgrw">
          Restore your spinal health and reclaim your life in just 30 days using a clinical visual method
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-72" data-mp="3o7lrboupx2nw">
          <img src="https://cdn.magicpatterns.com/uploads/u1FYvEbxES4QFunEp3woht/ChatGPT_Image_19_sept_2026,_16_16_02.png" alt="The 360 SPINAL SHIELD™: 6-Step Recovery System — 6-volume digital book plus 5 bonuses in digital format" width={1536} height={1024} sizes="(min-width: 640px) 672px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-73" data-mp="3ebioshvyf20f" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-74" data-mp="2hk84a0c7fpfn">
          ⭐ 4.9 · Join 450+ satisfied individuals recovering from chronic back pain · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-75" data-mp="id02omr47ymj">
          <CTAButton href="#pricing" data-id="element-76" data-mp="ddf2k907lk88">See the 360 System now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-77" data-mp="db2ede3uydmq">
            COMPLETE SPINAL RECOVERY COMBO 2026. The #1 system for office workers, athletes, and
            individuals suffering from herniated discs, sciatica, or chronic stiffness who need a
            real, progressive, and ready-to-use recovery protocol.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-78" data-mp="x033b2aqine3">
            Sciatica · Herniations · Lumbar Stiffness · Pelvic Instability · Muscle Guarding
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-79" data-mp="21aeg18zu476x">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-80" data-mp="268ofhvsldtyc">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-81" data-mp="2fz0yhjkrdf2d" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-82" data-mp="2kx2gs2ad1acs">
            - Everything you need in one place -
          </p>
        </div>

        

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-83" data-mp="2u03ilqs70fan">
          🔥 Limited-time offer · Then the price goes back up to $38
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-84" data-mp="e9a6023kouk3">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-85" data-mp="99xo7vrk6dod" />
          38 people are watching this product right now
        </p>
      </div>
    </header>;
}